import { IAppState } from 'shared/common/state';
import { NEWBUILDING_MONTHLY_PAYMENT } from 'shared/constants/experiments';
import { isAbUseExperimentGroup } from 'shared/utils/experiments/isAbUseExperimentGroup';

import { selectExperiments } from '../selectExperiments';

export const selectMortgageMonthlyPaymentExperiment = (state: IAppState) => {
  const experiments = selectExperiments(state);

  return isAbUseExperimentGroup(experiments, NEWBUILDING_MONTHLY_PAYMENT, 'B');
};
